export function postRegistration (values, history, locale) {
  //to do api call
  return (dispatch) => {
    dispatch(postRegistrationRequest());
    let url = `${process.env.REACT_APP_API_HOST}/register`;
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    values = {...values, 'locale': locale}

    return fetch(url, {method: 'POST', body: JSON.stringify(values), headers: headers })
      .then(response => {
        if (response.status === 200) {
          // history.push('/dashboard');
          return response;
        }
        else{
          throw(response);

        }
      })
      .then( response => response.json() )
      .then(response => {
        dispatch(postRegistrationSuccess(response.msg));
        return false;
      })
      .catch( (res) => {
        new Promise((resolve, reject)=>{
          resolve(res);
        })
        .then(resp => resp.json())
        .then( (r)=>{
          dispatch(postRegistrationError(r.msg));
        })
      })
  }
}

const postRegistrationRequest = () => {
  return {
    type: 'POST_REGISTRATION_REQUEST',
  }
}
const postRegistrationSuccess = (response) => {
  return {
    type: 'POST_REGISTRATION_SUCCESS',
    response
  }
}
const postRegistrationError = (error) => {
  return {
    type: 'POST_REGISTRATION_ERROR',
    error
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/registration.js